// $(document).ready(function() {
//     $("#cart-icon-bubble").click(function() {
//         $(".drawer.animate.active").toggle();
//     });
// });

    $(document).ready(function() {
      function getLanguageFromUrl() {
        const url = window.location.href;
        const languageMatch = url.match(/\/([a-z]{2})\//);
        return languageMatch ? languageMatch[1] : null;
      }

     
      function translatePrice(language) {
        switch (language) {
          case 'ar':
            $('#Details-2-template--21780798800150__product-grid .facets__summary div span').text('السعر');
            $('.product__text').text('متجري');
             $('.product-form__input').each(function() {
                var text = $(this).html();
                text = text.replace(/Size/g, 'مقاس');
                text = text.replace(/Grey/g, 'رمادي');
               text = text.replace(/White/g, 'أبيض');
               text = text.replace(/Yellow/g, 'أصفر');
               text = text.replace(/Red/g, 'أحمر');

                text = text.replace(/Regular/g, 'عادي');
                text = text.replace(/latest/g, '2');
                text = text.replace(/products/g, '3');
                $(this).html(text);
            });
    
    // jQuery('.product-form__input').html(text);

            break;
          default:
            $('#Details-2-template--21780798800150__product-grid .facets__summary div span').text('Price');
             $('.product__text').text('My Store');

        }
      }
      const initialLanguage = getLanguageFromUrl();
      if (initialLanguage) {
        translatePrice(initialLanguage);
      }

      
      $(window).on('popstate', function() {
        const currentLanguage = getLanguageFromUrl();
        if (currentLanguage) {
          translatePrice(currentLanguage);
        }
      });
    });
// $(document).ready(function() {
//     // Function to toggle the section based on screen width
//     function toggleSectionVisibility() {
//       if ($(window).width() <= 375) {
//         $('.refter').hide();
//         // $('.refter2').show();
//       } else {
//         $('.refter').show(); // Show the section for larger screen widths
//         // $('.refter2').hide();
//       }
//     }

//     // Initial call to set visibility based on window width
//     toggleSectionVisibility();

//     // Call the function whenever the window is resized
//     $(window).resize(function() {
//       toggleSectionVisibility();
//     });
//   });

 

